import { Request } from "../../hooks/Request";
import logotipoGA from "../../assets/LogotipoGA.png";
import logotipoLosAndes from "../../assets/LogotipoLosAndes.png";
import config from "../../config.json";
import { Circle } from "../../components/Animation";
import View from "../../components/GeneratePdf/View";
import { validateArray } from "../../utils/validate";
import Text from "../../components/GeneratePdf/Text";
import { Page, Document, PDFViewer, Image } from "@react-pdf/renderer";
import * as dayjs from "dayjs";

const RenderLiquidaciónProforma = (props) => {
  const { procedure } = props;
  const { data, loading } = Request({
    urlApi: `/gamarra/${procedure.id || procedure.procedureId}/proform`,
  });

  if (!loading) {
    return <Circle />;
  }
  const MyDoc = (
    <Document>
      <Page size="A4" style={{ padding: "20px" }}>
        <View alignItems="flex-end">
          <View>
            <Image
              src={config.isLosAndes ? logotipoLosAndes : logotipoGA}
              style={{ width: "250px" }}
            />
          </View>
          <View width="calc(100% - 250px)" justifyContent="center">
            <Text
              bold
              fontSize="14px"
              color="#ce0707"
              textAlign="center"
              style={{ textDecoration: "underline" }}
            >
              FO. LIQUIDACIÓN - PROFORMA
            </Text>
          </View>
        </View>
        <View style={{ marginTop: "8px" }} justifyContent="space-between">
          <View
            width="60%"
            borderContent
            flexDirection="column"
            style={{ borderRadius: "6px" }}
          >
            <Text bold textAlign="center" border={{ bottom: true }}>
              CLIENTE:
            </Text>
            <Text textAlign="center">{procedure.companyName}</Text>
          </View>
          <View width="39%" borderContent style={{ borderRadius: "6px" }}>
            <View width="40%" flexDirection="column" border={{ right: true }}>
              <Text bold textAlign="center" border={{ bottom: true }}>
                LUGAR
              </Text>
              <Text textAlign="center">{data.lugar}</Text>
            </View>
            <View width="20%" flexDirection="column" border={{ right: true }}>
              <Text bold textAlign="center" border={{ bottom: true }}>
                DÍA
              </Text>
              <Text textAlign="center">{dayjs().format("DD")}</Text>
            </View>
            <View width="20%" flexDirection="column" border={{ right: true }}>
              <Text bold textAlign="center" border={{ bottom: true }}>
                MES
              </Text>
              <Text textAlign="center">{dayjs().format("MM")}</Text>
            </View>
            <View width="20%" flexDirection="column">
              <Text bold textAlign="center" border={{ bottom: true }}>
                AÑO
              </Text>
              <Text textAlign="center">{dayjs().format("YYYY")}</Text>
            </View>
          </View>
        </View>
        <View
          borderContent
          flexDirection="column"
          style={{ marginTop: "8px", borderRadius: "6px" }}
        >
          <View border={{ bottom: true }}>
            <Text bold minWidth="70px" border={{ right: true }}>
              FOB $US:
            </Text>
            <Text minWidth="calc(40% - 70px)">{data.fobSus}</Text>
            <Text bold border={{ right: true, left: true }}>
              ADUANA:
            </Text>
            <Text>{data.aduana}</Text>
          </View>
          <View border={{ bottom: true }}>
            <Text bold minWidth="70px" border={{ right: true }}>
              VALOR CIF $US:
            </Text>
            <Text>{data.cifSus}</Text>
            <Text bold border={{ right: true, left: true }}>
              VALOR CIF BS.:
            </Text>
            <Text>{data.cifBs}</Text>
            <Text bold border={{ right: true, left: true }}>
              T/C:
            </Text>
            <Text>{data.tc}</Text>
          </View>
          <View border={{ bottom: true }}>
            <Text bold minWidth="70px" border={{ right: true }}>
              MERCADERÍA:
            </Text>
            <Text>{data.mercancia}</Text>
          </View>
          <View>
            <Text bold>PROVEEDOR:</Text>
            <Text>{data.proveedor}</Text>
            <Text bold>FACTURA:</Text>
            <Text>{data.factura}</Text>
          </View>
          <View>
            <Text bold>CÓDIGO DE CLIENTE:</Text>
            <Text>{data.codigoCliente}</Text>
          </View>
          <View>
            <Text bold>FECHA DE INICIO:</Text>
            <Text>{data.fechaLlegada}</Text>
            <Text bold>MONEDA:</Text>
            <Text>{data.moneda}</Text>
          </View>
          {/* <View>
            <Text bold>NÚMERO DE PARCIAL:</Text>
            <Text>{data.numeroParcial}</Text>
          </View> */}
        </View>
        <Text
          bold
          fontSize="12px"
          color="#ce0707"
          style={{ marginTop: "8px", textDecoration: "underline" }}
        >
          FO. LIQUIDACIÓN - PROFORMA
        </Text>
        <View borderContent flexDirection="column" style={{ borderRadius: 6 }}>
          <View border={{ bottom: true }}>
            <View width="50%" flexDirection="column">
              <View>
                <View
                  width="50%"
                  justifyContent="center"
                  alignItems="center"
                  border={{ bottom: true }}
                >
                  <Text bold textAlign="center">
                    REQUISITOS LEGALES
                  </Text>
                </View>
                <View
                  width="50%"
                  justifyContent="center"
                  alignItems="center"
                  border={{ bottom: true }}
                >
                  <Text bold textAlign="center">
                    LIQUIDACIÓN
                  </Text>
                </View>
              </View>
              <View>
                <View width="50%" justifyContent="center" alignItems="center">
                  <Text textAlign="center">FOB:</Text>
                </View>
                <View width="50%" justifyContent="flex-end" alignItems="center">
                  <Text textAlign="center">{data.fob}</Text>
                </View>
              </View>
              <View>
                <View width="50%" justifyContent="center" alignItems="center">
                  <Text textAlign="center">FLETE I:</Text>
                </View>
                <View width="50%" justifyContent="flex-end" alignItems="center">
                  <Text textAlign="center">{data.fleteI}</Text>
                </View>
              </View>
              <View>
                <View width="50%" justifyContent="center" alignItems="center">
                  <Text textAlign="center">FLETE II:</Text>
                </View>
                <View width="50%" justifyContent="flex-end" alignItems="center">
                  <Text textAlign="center">{data.fleteII}</Text>
                </View>
              </View>
              <View>
                <View width="50%" justifyContent="center" alignItems="center">
                  <Text textAlign="center">SEGURO:</Text>
                </View>
                <View width="50%" justifyContent="flex-end" alignItems="center">
                  <Text textAlign="center">{data.seguro}</Text>
                </View>
              </View>
              <View>
                <View width="50%" justifyContent="center" alignItems="center">
                  <Text textAlign="center">OTROS GASTOS:</Text>
                </View>
                <View width="50%" justifyContent="flex-end" alignItems="center">
                  <Text textAlign="center">{data.otrosGastos}</Text>
                </View>
              </View>
              <View>
                <View width="50%" justifyContent="center" alignItems="center">
                  <Text textAlign="center">OTRAS EROGACIONES:</Text>
                </View>
                <View width="50%" justifyContent="flex-end" alignItems="center">
                  <Text textAlign="center">{data.otrasErogaciones}</Text>
                </View>
              </View>
              <View>
                <View width="50%" justifyContent="center" alignItems="center">
                  <Text textAlign="center">GTOS.PORTOARIOS:</Text>
                </View>
                <View width="50%" justifyContent="flex-end" alignItems="center">
                  <Text textAlign="center">{data.gastosPortuarios}</Text>
                </View>
              </View>
              <View>
                <View width="50%" justifyContent="center" alignItems="center">
                  <Text textAlign="center">VALOR CIF $us.:</Text>
                </View>
                <View width="50%" justifyContent="flex-end" alignItems="center">
                  <Text textAlign="center">{data.cifSus}</Text>
                </View>
              </View>
              <View>
                <View width="50%" justifyContent="center" alignItems="center">
                  <Text textAlign="center">VALOR CIF Bs.:</Text>
                </View>
                <View width="50%" justifyContent="flex-end" alignItems="center">
                  <Text textAlign="center">{data.cifBs}</Text>
                </View>
              </View>
            </View>
            <View width="50%" flexDirection="column" border={{ left: true }}>
              <Text bold textAlign="center" border={{ bottom: true }}>
                IMPUESTOS
              </Text>
              <View>
                <View width="50%" flexDirection="column">
                  <Text>GRAVAMEN ARANCELARIO</Text>
                  <Text>IMPUESTO AL VALOR AGREGADO</Text>
                  <Text>IMPUESTOS GLOBALES</Text>
                  <Text>ICE</Text>
                  <Text>IDH</Text>
                </View>
                <View width="50%" flexDirection="column">
                  <Text textAlign="right">{data.gravamenArancelario}</Text>
                  <Text textAlign="right">{data.iva}</Text>
                  <Text textAlign="right">{data.impuestosGlobales}</Text>
                  <Text textAlign="right">{data.ice}</Text>
                  <Text textAlign="right">{data.idhCarburantes}</Text>
                </View>
              </View>
            </View>
          </View>
          <View>
            <View
              width="80%"
              border={{ right: true }}
              justifyContent="flex-end"
            >
              <Text bold>TOTAL Bs.:</Text>
            </View>
            <Text textAlign="center">{data.totalLiquidacionBs}</Text>
          </View>
        </View>
        <Text
          bold
          fontSize="12px"
          color="#ce0707"
          style={{ marginTop: "8px", textDecoration: "underline" }}
        >
          PROFORMA NRO.: {data.nroTramite}
        </Text>
        <View borderContent flexDirection="column" style={{ borderRadius: 6 }}>
          <View border={{ bottom: true }}>
            <View width="80%" flexDirection="column">
              <Text
                bold
                textAlign="center"
                border={{ bottom: true, right: true }}
              >
                DESCRIPCIÓN
              </Text>
              {data.gastosDespacho !== "-" && <Text>GASTOS DE DESPACHO</Text>}
              {data.almacenaje !== "-" && <Text>ALMACENAJE</Text>}
              {data.comisionAgencia !== "-" && <Text>COMISIÓN AGENCIA</Text>}
              {validateArray(data.subDatas)
                ? data.subDatas.map((subData, index) => (
                    <Text>{subData.label}</Text>
                  ))
                : null}
            </View>
            <View width="20%" flexDirection="column">
              <Text bold textAlign="center" border={{ bottom: true }}>
                GASTOS
              </Text>
              {data.gastosDespacho !== "-" && (
                <Text textAlign="right">{data.gastosDespacho}</Text>
              )}

              {data.almacenaje !== "-" && <Text textAlign="right">{data.almacenaje}</Text>}
              {data.comisionAgencia !== "-" && (
                <Text textAlign="right">{data.comisionAgencia}</Text>
              )}
              {validateArray(data.subDatas)
                ? data.subDatas.map((subData, index) => (
                    <Text textAlign="right">{subData.numberValue}</Text>
                  ))
                : null}
            </View>
          </View>
          <View>
            <View
              width="80%"
              border={{ right: true }}
              justifyContent="flex-end"
            >
              <Text bold>TOTAL PROFORMA Bs.:</Text>
            </View>
            <Text textAlign="center">{data.totalProforma}</Text>
          </View>
        </View>
        <View
          borderContent
          flexDirection="column"
          style={{ borderRadius: "8px", marginTop: "8px" }}
        >
          <View>
            <View
              width="80%"
              border={{ right: true }}
              justifyContent="flex-end"
            >
              <Text color="#ce0707" bold>
                TOTAL Bs.:
              </Text>
            </View>
            <Text textAlign="center">{data.total}</Text>
          </View>
          <Text bold border={{ top: true }}>
            SON: {data.totalEnteroString} {data.totalDecimalString}
          </Text>
        </View>
      </Page>
    </Document>
  );

  return (
    <div>
      <PDFViewer
        style={{
          width: 900,
          height: window.innerHeight - 100,
        }}
        children={MyDoc}
      />
    </div>
  );
};

export default RenderLiquidaciónProforma;
